import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Layout/index.vue'
import loginRoutes from '@/pages/Authentication/router'
import signUpRoutes from '@/pages/SignUp/router'
// import newOrganizationRoutes from '@/pages/NewOrganization/router'
// import updatePayment from '@/pages/UpdatePayment/router'
import homeRoutes from '@/pages/Home/router'
import locationRoutes from '@/pages/Location/router'
import groupRoutes from '@/pages/Group/router'
import reportRoutes from '@/pages/Report/router'
import batchRoutes from '@/pages/Batch/router'
import userRoutes from '@/pages/User/router'
import adsRoutes from '@/pages/AdImage/router'
import globalRoutes from '@/pages/Global/router'
import invoiceRoutes from '@/pages/Invoice/router'
import LocationInvoiceView from '@/pages/Report/components/Invoice/View.vue'


Vue.use(Router);

let mainRoutes = []
mainRoutes = mainRoutes.concat(homeRoutes)
mainRoutes = mainRoutes.concat(locationRoutes)
mainRoutes = mainRoutes.concat(groupRoutes)
mainRoutes = mainRoutes.concat(reportRoutes)
mainRoutes = mainRoutes.concat(batchRoutes)
mainRoutes = mainRoutes.concat(userRoutes)
mainRoutes = mainRoutes.concat(adsRoutes)

let routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: mainRoutes,
    redirect: { path: '/home' },
    beforeEnter: (to, from, next) => {
      if ((localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null)) {
        console.log('No token was found') // eslint-disable-line
        next({
          path: '/login',
          params: { nextUrl: to.fullPath },
        })
      } else {
        next()
      }
    },
  },
  {
    path: '/location/:storeId/invoice/:invoiceId/view',
    name: 'view-location-invoice',
    component: LocationInvoiceView,
    props: true,
  },
]

// Add login routes to the app.
routes = routes.concat(loginRoutes)
routes = routes.concat(signUpRoutes)
// routes = routes.concat(updatePayment)
routes = routes.concat(globalRoutes)
routes = routes.concat(invoiceRoutes)

// routes = routes.concat(newOrganizationRoutes)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

export default router
